export default "__VITE_ASSET__nT_7y5xE__";